import { CREATE_SOLR_COLLECTION } from '../../constants/ActionTypes';
import { DELETE_SOLR_COLLECTION } from '../../constants/ActionTypes';
import { GET_SOLR_COLLECTIONS } from '../../constants/ActionTypes';

export const initialState = {
  result: {},
};

export default function solrcollection(state = initialState, action = {}) {
  switch (action.type) {
    case `${CREATE_SOLR_COLLECTION}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${CREATE_SOLR_COLLECTION}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        result: action.result,
      };
    case `${CREATE_SOLR_COLLECTION}_FAIL`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: false,
      };

    case `${DELETE_SOLR_COLLECTION}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${DELETE_SOLR_COLLECTION}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        result: action.result,
      };
    case `${DELETE_SOLR_COLLECTION}_FAIL`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: false,
      };

    case `${GET_SOLR_COLLECTIONS}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_SOLR_COLLECTIONS}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        result: action.result,
      };
    case `${GET_SOLR_COLLECTIONS}_FAIL`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: false,
      };

    default:
      return state;
  }
}
